export const SignatureProfileInstagram = ({ profile }: { profile: any }) => {
  const instagram = Array.isArray(profile?.instagrams)
    ? profile.instagrams[0]
    : undefined;

  const profileTag: string | undefined = instagram?.profileTag || undefined;
  const visitLink: string | undefined = instagram?.visitLink || undefined;
  const posts: string[] = Array.isArray(instagram?.posts)
    ? (instagram.posts as string[]).filter(Boolean)
    : [];

  const hasHeader = Boolean(profileTag || visitLink);
  const hasPosts = posts.length > 0;

  if (!hasHeader && !hasPosts) return null;

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8">
          {/* 20. Signature profile instagram  */}
          <div>
            <h2 className="font-playfair text-3xl font-bold mb-2">
              Follow on Instagram
            </h2>
            {profileTag ? (
              <p className="text-muted-foreground">@{profileTag}</p>
            ) : null}
          </div>
          {visitLink ? (
            <a
              href={visitLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 mt-4 md:mt-0 rounded-full bg-gradient-to-r from-purple-500 to-pink-500"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-instagram mr-2"
              >
                <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
              </svg>
              Follow
            </a>
          ) : null}
        </div>
        {/* 21. Signature profile instagram posts (emdeded code)  */}
        {hasPosts ? (
          <div className="grid grid-cols-2 md:grid-cols-3 gap-2 md:gap-4">
            {posts.map((embed, idx) => (
              <div
                key={idx}
                className="overflow-hidden rounded-lg"
                dangerouslySetInnerHTML={{ __html: embed as string }}
              />
            ))}
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default SignatureProfileInstagram;
